// export function removeSpaces(value) {
// 	return String(value)
// 		.replace(/[^0-9.,]/g, '')
// 		.replace(/\s+/g, '')
// }

export const removeSpaces = (value) => {
	if (!value) return ''
	const stringValue = typeof value === 'string' ? value : String(value)
	const replaced = stringValue.replace(/\s/g, '').replace(/,/g, '.')

	// keep only the first dot
	const firstDot = replaced.indexOf('.')
	if (firstDot === -1) return replaced
	return (
		replaced.slice(0, firstDot + 1) +
		replaced.slice(firstDot + 1).replace(/\./g, '')
	)
}
